/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Remove_TitleInputs */



/**
* | output |
* | --- |
* | "Remove connector package?" |
*
* @param {Partner_Connectors_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_remove_title = /** @type {((inputs?: Partner_Connectors_Remove_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Remove_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konnektor-Paket entfernen?")
	return /** @type {LocalizedString} */ ("Remove connector package?")
});